export const getNameInitials = ({ name }) => {
  if (!name) {
    return "";
  }
  return name
    .split(" ")
    .map((n) => n[0])
    .join("");
};

export const formatDate = (dateInput) => {
  const date = new Date(dateInput);
  const options = { day: "numeric", month: "long", year: "numeric" };
  return new Intl.DateTimeFormat("en-GB", options).format(date);
};

export function formatDateTimeNotifications(date) {
  if (date === null) {
    return "";
  }
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12;

  const minutesFormatted = minutes < 10 ? "0" + minutes : minutes;

  const timePart = `${hours}:${minutesFormatted} ${ampm}`;

  const datePart = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })
    .format(date)
    .replace(/ /g, " ");

  return `${timePart} ${datePart}`;
}

export const loadRazorPayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => {
      resolve(true);
    };
    document.body.appendChild(script);
  });
};

export const formatMobileNumber = (number) => {
  if (number?.length === 10) {
    return `${number?.slice(0, 5)} ${number?.slice(5, 10)}`;
  }
  return number;
};
export function getLabel(count, singular, plural) {
  return count === 1 ? singular : plural;
}

export const formatAmount = (amount, unit = "₹") => {
  if (isNaN(amount)) {
    return amount;
  }

  const num = Number(amount);

  return (
    unit +
    num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
};
